import React, { useEffect } from 'react';
import { useAuth } from '../context/authContext.tsx';
import { Link, useNavigate } from 'react-router';
import { digitalOceanImageUrl } from "../utils/digitalOcean.ts";

export const Distruption = () => {
    const {employeeI, authReady} = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (!authReady) {
            return;
        }

        if (!employeeI) {
            navigate('/login', {replace: true});
            return;
        }

        // if (employeeI.division !== 1 && employeeI.email !== "gzake@kiiramotors.com"  && employeeI.email !== "rmadanda@kiiramotors.com" && employeeI.email !== "aziryawulawo@kiiramotors.com" && employeeI.unit !== 15) {
        //     navigate('/client/vehicle-models', {replace: true});
        //     return;
        // }
    }, [authReady, employeeI, navigate]);


  return (
    <div>
        <Link to={`/admin-vehicle-models`}>Admin</Link>
        <Link to={`/client/vehicle-models`}>Client</Link>
        <div className="relative min-h-screen w-full overflow-hidden bg-white">
            {/* Background Image Container */}
            <div 
                className="fixed inset-0 w-full h-full bg-cover bg-center"
                style={{
                    backgroundImage: `url('${digitalOceanImageUrl("assets/images/WIP-FRONT.jpg")}')`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-blue-900/40"></div>
            </div>
            
            {/* Content Container */}
            <div className="relative z-10 min-h-screen flex flex-col items-center justify-between p-4">
                {/* Logo and Main Content */}
                <div className="w-full flex flex-col items-center justify-center flex-grow">
                    {/* Logo */}
                    <div className="mb-6 sm:mb-8 w-full flex justify-center">
                        <img 
                            src={digitalOceanImageUrl("assets/images/logo.png")} 
                            alt="KMC Logo" 
                            className="h-12 sm:h-20"
                        />
                    </div>
                    
                    {/* Title */}
                    <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-8 sm:mb-12 text-center px-4">
                        Production Processes Portal
                    </h1>
                    <div className='flex  gap-10'>
                        <button 
                            onClick={() => navigate("/client/vehicle-models")}
                            className="bg-blue-800 hover:bg-blue-700 text-white font-semibold gap-2 py-3 px-12 rounded-full text-lg sm:text-xl transition-all duration-300 shadow-lg hover:shadow-xl hover:animation:none motion-safe:animate-pulse"
                        >
                            Client 
                        </button>

                        <button 
                            onClick={() => navigate("/admin-vehicle-models")}
                            className="bg-blue-800 hover:bg-blue-700 text-white font-semibold py-3 gap-2 px-12 rounded-full text-lg sm:text-xl transition-all duration-300 shadow-lg hover:shadow-xl hover:animation:none motion-safe:animate-pulse"
                        >
                            Admin
                        </button>
                    </div>
                    {/* Access Button */}
                   
                </div>
                
                {/* Footer */}
                <div className="w-full text-center text-white/70 text-sm pb-4">
                    <p>© {new Date().getFullYear()} KMC • All Rights Reserved</p>
                </div>
            </div>
        </div>  

    </div>
  )
}
